import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';

interface AuditPagerProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

const PAGE_SIZES = [25, 50, 100, 250];

/** Page x of n, the total, rows per page, previous / next. */
export const AuditPager: React.FC<AuditPagerProps> = ({ page, totalPages, total, pageSize, onPageChange, onPageSizeChange }) => {
  const { formatNumber, t } = useI18n();
  return (
    <div className="aud-pager">
      <div className="aud-pager-info">
        <span>{t('audit.pagination.pageOf', { page, total: totalPages })}</span>
        <span className="tpl-muted">· {t('audit.pagination.total', { count: formatNumber(total) })}</span>
      </div>
      <div className="aud-pager-controls">
        <label htmlFor="audit-page-size" className="tpl-muted">{t('audit.pagination.pageSize')}</label>
        <select id="audit-page-size" className="tpl-select aud-page-size" value={pageSize} onChange={(e) => onPageSizeChange(Number(e.target.value))} data-testid="audit-page-size">
          {PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
        <button type="button" className="btn btn-secondary btn-sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          {t('audit.pagination.prev')}
        </button>
        <button type="button" className="btn btn-secondary btn-sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
          {t('audit.pagination.next')}
        </button>
      </div>
    </div>
  );
};
